var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container text-center"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h1',{staticStyle:{"margin-top":"100px"}},[_vm._v("404 Not Found")])])])])
}]

export { render, staticRenderFns }